import React, { useState } from "react";
import {
  Dialog,
  TextField,
  Paper,
  InputAdornment,
  CircularProgress,
  IconButton,
  DialogContent,
  DialogContentText,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Chip,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import PhoneIcon from "@material-ui/icons/Phone";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const PhoneModal = ({ open, onClose, wavoipToken, whatsappData, user, backendUrl }) => {
  const [contactSearch, setContactSearch] = useState("");
  const [contacts, setContacts] = useState([]);
  const [loadingContacts, setLoadingContacts] = useState(false);

  const handleClose = () => {
    setContactSearch("");
    setContacts([]);
    onClose();
  };

  const handleContactSearch = async (e) => {
    const value = e.target.value;
    setContactSearch(value);
    
    if (value && value.length >= 2) {
      setLoadingContacts(true);
      try {
        const { data } = await api.get("/contacts/list", {
          params: { name: value }
        });
        setContacts(data || []);
      } catch (err) {
        console.error("Erro ao buscar contatos:", err);
        setContacts([]);
      } finally {
        setLoadingContacts(false);
      }
    } else {
      setContacts([]);
    }
  };

  const handleCallClick = (contact) => {
    console.log("Chamando:", contact);
    toast.success(`Chamando ${contact.name}...`);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          maxHeight: '90vh',
          backgroundColor: '#f5f5f5',
        }
      }}
    >
      {wavoipToken ? (
        <div style={{ padding: '16px' }}>
          {/* Campo de Busca */}
          <TextField
            fullWidth
            placeholder="Buscar contato..."
            variant="outlined"
            value={contactSearch}
            onChange={handleContactSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: loadingContacts ? (
                <CircularProgress color="inherit" size={20} />
              ) : null,
            }}
            style={{ marginBottom: '16px', backgroundColor: 'white' }}
          />

          {/* Lista de Contatos */}
          <List style={{ maxHeight: '400px', overflow: 'auto' }}>
            {contacts.map((contact) => (
              <ListItem
                key={contact.id}
                style={{
                  backgroundColor: 'white',
                  marginBottom: '8px',
                  borderRadius: '8px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '12px'
                }}
              >
                <ListItemAvatar>
                  <Avatar style={{ width: 40, height: 40 }}>
                    {contact.name?.charAt(0).toUpperCase() || '?'}
                  </Avatar>
                </ListItemAvatar>

                <ListItemText
                  primary={contact.name || 'Sem nome'}
                  secondary={contact.number}
                  style={{ flex: 1, marginLeft: '12px' }}
                />

                <IconButton
                  size="small"
                  onClick={() => handleCallClick(contact)}
                  style={{ color: '#e91e63' }}
                >
                  <PhoneIcon />
                </IconButton>
              </ListItem>
            ))}
          </List>

          {contacts.length === 0 && contactSearch && (
            <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
              Nenhum contato encontrado
            </div>
          )}
        </div>
      ) : (
        <DialogContent style={{ backgroundColor: 'white', borderRadius: '8px', padding: 20 }}>
          <DialogContentText style={{ textAlign: 'center' }}>
            ⚠️ Token Wavoip não encontrado. Configure o token no WhatsApp.
          </DialogContentText>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default PhoneModal;
